const t = {
  name: "Filter",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2H22V6.17C22 6.97089 21.6806 7.72362 21.1171 8.28711L15 14.4042V18.4042L11.4142 21.99H9V14.4042L2.88713 8.29134C2.31243 7.72896 2 6.96078 2 6.17V2ZM4 4V6.17C4 6.43682 4.10567 6.68637 4.28762 6.86353L4.29717 6.87283L11 13.5758V19.5758L13 17.5758V13.5758L19.7029 6.87289C19.8994 6.67638 20 6.42911 20 6.17V4H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Filter
};
